export enum MarketplaceProduct {
  FLEXSAVE = "doit-flexsave",
  COST_ANOMALY_DETECTION = "doit-cloud-cost-anomaly-detection",
  SAAS_CONSOLE = "doit-console",
  DOIT_CLOUD_INTELLIGENCE = "doit-cloud-intelligence",
}

export enum CustomerPageUrl {
  FLEXSAVE = "flexsave-gcp",
  DOIT_CLOUD_INTELLIGENCE_MARKETPLACE = "doit-cloud-intelligence-gcp",
  GCP_LENS = "dashboards/GCP Lens",
  HOME = "home",
  DEFAULT = "/",
  SAAS_CONSOLE_AWS = "cloud-onboarding-aws",
  SAAS_CONSOLE_GCP = "cloud-onboarding-gcp",
  DASHBOARDS = "dashboards",
}
